import { render, staticRenderFns } from "./CampanhaVendaMargemGerente.vue?vue&type=template&id=634d01fc"
import script from "./CampanhaVendaMargemGerente.vue?vue&type=script&lang=js"
export * from "./CampanhaVendaMargemGerente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports